<template>
    <div class="back-drop" v-if="showSuc" @click="showSuc=false">
        <div class="img-container">
            <img src="../../../../images/vip/upgrade-suc.png" alt="">
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return {
                showSuc:false
            }
        },
        methods:{
            open(){
                this.showSuc = true;
            }
        }
    }
</script>
<style scoped>
    .back-drop{
        position:fixed;
        top:0;
        bottom:0;
        left:0;
        right:0;
        z-index:1001;
        background-color:rgba(0,0,0,0.69);
    }
    .back-drop .img-container{
        width:540px;
        height:540px;
        position:absolute;
        top:50%;
        left:50%;
        margin-top:-270px;
        margin-left:-270px;
    }
</style>
